import { FC, useCallback } from 'react';

import { endOfMonth, parseISO, startOfMonth } from 'date-fns';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import SingleCalendarPicker from 'bloko/blocks/calendar/SingleCalendarPicker';
import DropDownClick, { DownPlacement } from 'bloko/blocks/drop/Down/Click';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import InputText from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import { setCurrentDate } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const InputWithDatePicker: FC = () => {
    const currentDate = useSelector((state) => state.acts.currentDate);

    const dispatch = useDispatch();

    const trl = useTrls();

    const onDateClick = useCallback(
        (date?: string) => {
            if (date) {
                dispatch(setCurrentDate(startOfMonth(parseISO(date))));
            }
        },
        [dispatch]
    );
    return (
        <DropDownClick
            render={() => (
                <SingleCalendarPicker
                    initialDate={formatDate(currentDate)}
                    highlighted={formatDate(currentDate)}
                    onDateClick={onDateClick}
                />
            )}
            placement={DownPlacement.BottomEnd}
        >
            <InputText
                placeholder={trl('admin.actsReport.filter.input')}
                size={30}
                icon={<Icon view={IconView.Calendar} scale={IconScale.Small} />}
                value={`${formatDate(currentDate, VIEW_DATE_FORMAT)} - ${formatDate(
                    endOfMonth(currentDate),
                    VIEW_DATE_FORMAT
                )}`}
                onChange={() => undefined}
            />
        </DropDownClick>
    );
};

export default InputWithDatePicker;
